import {
  ErrorMessage,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import React from 'react';
import { Box, Image } from '@chakra-ui/react';
import { MeetingTypePickerSkeleton } from './MeetingTypePickerSkeleton';
import { MeetingTypeButton } from './MeetingTypeButton';
import { ProviderType } from '../../api/types';
import { MeetingType } from '../../models/meeting';
import type { AppointmentOption } from './hooks/useSelectMeetingType';

const clipboardSvgUri = '/clipboard.svg';

type Props = {
  appointmentOptions: AppointmentOption[];
  isError: boolean;
  isLoading: boolean;
  onSelectMeetingType: (
    providerType: ProviderType,
    meetingType: MeetingType
  ) => void;
};

export const MeetingTypePicker = ({
  appointmentOptions,
  isError,
  isLoading,
  onSelectMeetingType,
}: Props) => {
  if (isError) {
    return (
      <ErrorMessage
        message={
          'Sorry, an error occurred while trying to retrieve the data. Please try again or contact support.'
        }
      />
    );
  }

  return (
    <VStack>
      <HStack alignItems={'center'} justifyContent={'space-between'} mb={8}>
        <Text color={'blueGray.600'} fontSize={'14px'} fontWeight={'normal'}>
          Step 1: Select Visit Type
        </Text>
      </HStack>

      {isLoading && <MeetingTypePickerSkeleton />}

      {!isLoading && (
        <HStack>
          <HStack flex={3} flexWrap={'wrap'} gap={3} alignItems={'flex-start'}>
            {appointmentOptions.map((option) => (
              <Box key={option.healthieId} flex={'1 1 200px'} maxW={'260px'}>
                <MeetingTypeButton
                  disabled={!option.enabled}
                  onClick={() => {
                    onSelectMeetingType(option.providerType, option.meetingType);
                  }}
                  subText={option.meetingType}
                  text={option.displayName}
                />
              </Box>
            ))}
          </HStack>

          <HStack flex={{ base: 0, lg: 2 }} position={'relative'}>
            <Image
              alt={'clipboard icon'}
              bottom={'-32px'}
              height={'215px'}
              position={'absolute'}
              right={'-48px'}
              src={clipboardSvgUri}
              width={'310px'}
            />
          </HStack>
        </HStack>
      )}
    </VStack>
  );
};
